import React from "react";
import {
  styled,
  Theme,
  ToggleButton,
  ToggleButtonGroup,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const StyledToggleGroup = styled(ToggleButtonGroup, {
  shouldForwardProp: (prop) => prop !== "collapseHeader",
})<{
  collapseHeader: boolean;
  fullWidth?: boolean;
}>`
  width: ${({ collapseHeader, fullWidth }) =>
    collapseHeader || fullWidth ? "100%" : "auto"};
`;

const toggleButtonStyle = {
  height: 30,
  whiteSpace: "nowrap",
  minWidth: "170px",
};

const toggleButtonCollapsedStyle = {
  minWidth: 0,
  whiteSpace: "wrap",
  height: "auto",
  padding: "4px 5px!important",
};

interface Props {
  value: string;
  handleViewChange: (
    event: React.MouseEvent<HTMLElement>,
    value: string
  ) => void;
  collapseHeader: boolean;
  fullWidth?: boolean;
}

export const ToggleGroup = ({
  value,
  handleViewChange,
  collapseHeader,
  fullWidth,
}: Props) => {
  const { t } = useTranslation();
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <StyledToggleGroup
      exclusive
      value={value}
      size="small"
      onChange={handleViewChange}
      collapseHeader={collapseHeader}
      fullWidth={fullWidth}
    >
      <ToggleButton
        disabled={value === "chart"}
        value="chart"
        sx={{
          ...(collapseHeader ? toggleButtonCollapsedStyle : toggleButtonStyle),
        }}
      >
        {t("dashboardPage.currentAssetsBlock.chart")}
      </ToggleButton>
      <ToggleButton
        disabled={value === "gainersLosers"}
        value="gainersLosers"
        sx={{
          ...(collapseHeader ? toggleButtonCollapsedStyle : toggleButtonStyle),
        }}
      >
        {isLessSm
          ? t("dashboardPage.currentAssetsBlock.gainersLosersShort")
          : t("dashboardPage.currentAssetsBlock.gainersLosers")}
      </ToggleButton>
    </StyledToggleGroup>
  );
};
